import React from "react";
import { useNavigate, useOutletContext } from "react-router";
import MainLayout from "../../components/Common/MainLayout/MainLayout";
import { reports } from "../../utils/mainTabs/reports/reports";
import { tileSize } from "../../utils/tileSizes";
import { tileTypes } from "../../utils/tileTypes";

const ReportPage = () => {
  const { name, tiles } = reports;
  const navigate = useNavigate();
  const { tenantName } = useOutletContext();

  return (
    <MainLayout
      heading={name}
      tiles={tiles(navigate, tenantName)}
      tileType={tileTypes.SMALL}
      tileSize={tileSize.SMALL}
    ></MainLayout>
  );
};

export default ReportPage;
